//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SitesSessionStorageService } from "@nuskin/ns-util";
import { NsIcon } from "@nuskin/design-components";

export default {
  name: "NsHeaderMarketingMessage",
  components: { NsIcon },
  props: {
    /**
     * Message object; requires 'info', 'href', and 'link'
     */
    message: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  mounted() {
    const dismissMarketingMessage = SitesSessionStorageService.getItem(
      "dismissMarketingMessage"
    );
    if (dismissMarketingMessage) {
      this.close();
    }
  },
  methods: {
    close(event) {
      if (event) {
        SitesSessionStorageService.writeItem("dismissMarketingMessage", true);
      }
      this.$emit("close");
    }
  }
};
